import { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { usePaginationLogic } from "./usePaginationLogic";

export const usePagination = (
  totalItems,
  itemsPerPage = 10,
  withoutQuery = false
) => {
  const router = useRouter();
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    if (!withoutQuery) {
      const route = { query: { ...router.query, page: page } };
      router.push(route, undefined, { shallow: true });
    }
  }, [page]);

  const goToPreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const goToNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const paginationItems = usePaginationLogic(page, totalPages);

  return {
    setPage,
    page,
    goToPreviousPage,
    goToNextPage,
    totalPages,
    paginationItems,
  };
};
